import { Auth } from '@efishery/sdk-core';
import { AUTH_V2_CLIENT_ID, AUTH_V2_STAGE } from '@/configs';

export const auth = new Auth(AUTH_V2_CLIENT_ID, AUTH_V2_STAGE);
